import * as types from "./personalDataActionTypes";

export default function personalDataReducer(state = {}, action) {
    switch (action.type) {
        case types.CLEAR: {
            const newData = { [action.model.name]: {} };
            return { ...state, ...newData };
        }
        case types.HAS_PERSONAL_DATA_FORM: {
            const newData = { hasPersonalDataForm: { loaded: false } };
            return { ...state, ...newData };
        }
        case types.HAS_PERSONAL_DATA_FORM_SUCCESS: {

            const newData = {
              hasPersonalDataForm: { ...action.payload.data, loaded: true },
            };
            return { ...state, ...newData };
        }
        case types.HAS_PERSONAL_DATA_FORM_FAILURE: {
            const newData = { hasPersonalDataForm: { loaded: false } };
            return { ...state, ...newData };
        }

        case types.AUTHENTICATE_MEMBER: {
            const newData = { memberFormData: { loaded: false } };
            return { ...state, ...newData };
        }
        case types.AUTHENTICATE_MEMBER_FAILURE:
        case types.AUTHENTICATE_MEMBER_SUCCESS: {
            const newData = {
                memberFormData: { ...action.payload, loaded: true },
            };
            return { ...state, ...newData };
        }
        case types.PERSONAL_DATA_PATCH: {
            const newData = { personalDataUpdate: { submitting: true, completed: false } };
            return { ...state, ...newData };
        }
        case types.PERSONAL_DATA_PATCH_FAILURE:
        case types.PERSONAL_DATA_PATCH_SUCCESS: {
            const newData = {
                personalDataUpdate: { ...action.payload, submitting: false, completed: true },
            };
            return { ...state, ...newData };
        }

        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/personal-data/personalDataReducer.js